import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import { BankAccountDto } from "./type";

//BankAccount
export const getBankAccountSaga = createAction(
  "GET_BANK_ACCOUNT",
  ({ payload, params }: SagaActionParams<BankAccountDto[]>) => ({
    payload,
    url: "/api/admin/bankaccounts" + (params ? params : ""),
  })
);
export const getBankAccountDetailsSaga = createAction(
  "GET_BANK_ACCOUNT_DETAILS",
  ({ payload, id }: SagaActionParams<BankAccountDto>) => ({
    payload,
    url: "/api/admin/bankaccounts/" + id,
  })
);
export const createBankAccountSaga = createAction(
  "CREATE_BANK_ACCOUNT",
  ({ payload, body }: SagaActionParams<BankAccountDto>) => ({
    payload,
    url: "/api/admin/bankaccounts",
    body,
  })
);
export const updateBankAccountSaga = createAction(
  "UPDATE_BANK_ACCOUNT",
  ({ payload, id, body }: SagaActionParams<BankAccountDto>) => ({
    payload,
    url: "/api/admin/bankaccounts/" + id,
    body,
  })
);
export const deleteBankAccountSaga = createAction(
  "DELETE_BANK_ACCOUNT",
  ({ payload, id }: SagaActionParams<BankAccountDto>) => ({
    payload,
    url: "/api/admin/bankaccounts/" + id,
  })
);
const BankAccountSaga = [
  takeLatest<any>(
    getBankAccountSaga.toString(),
    (payload: SagaGenericParams<BankAccountDto[]>) =>
      getSaga<BankAccountDto[]>(payload)
  ),
  takeLatest<any>(
    getBankAccountDetailsSaga.toString(),
    (payload: SagaGenericParams<BankAccountDto>) =>
      getSaga<BankAccountDto>(payload)
  ),
  takeLatest<any>(
    createBankAccountSaga.toString(),
    (payload: SagaGenericParams<BankAccountDto>) =>
      postSaga<BankAccountDto>(payload)
  ),
  takeLatest<any>(
    updateBankAccountSaga.toString(),
    (payload: SagaGenericParams<BankAccountDto>) =>
      putSaga<BankAccountDto>(payload)
  ),
  takeLatest<any>(
    deleteBankAccountSaga.toString(),
    (payload: SagaGenericParams<any>) => deleteSaga<BankAccountDto>(payload)
  ),
];

export default BankAccountSaga;
